 import axios, { AxiosResponse, AxiosError } from "axios";
 import {  toast } from 'react-toastify';
 import 'react-toastify/dist/ReactToastify.css';

  export const getOTP = (
    phone_number: any,
    country_code: any,
    from_register:any,
    successCallBack: (message: any) => void,
    errorCallBack: (errorMessage: any) => void
  ) => {
    const payload = {
      phone_number:phone_number,
      country_code:country_code,
      from_register:from_register
    };
    axios.post(`${global.api_url}/api/generate_otp`, payload)
    .then((response: AxiosResponse) => {
      successCallBack(response);
    })
    .catch((error: AxiosError) => {
      if (error.response?.status === 400) {
        errorCallBack(error);
      }
      else if  (error.response?.status === 401){
        localStorage.clear();
      }
      else{
        errorCallBack(error);
      }
    });
  }
  export const registerUser = (
    name:string,
    phone: any,
    countryCode: any,
    password: any,
    password_confirmation: any,
    otp: any,
    device_id: any,
    fcm_token: string,
    successCallBack: (message: any) => void,
    errorCallBack: (errorMessage: any) => void
  ) => {
    var cCode = countryCode.replace("+", "");
    const payload = {
      name:name,
      phone: phone,
      country_code: cCode,
      password: password,
      password_confirmation: password_confirmation,
      otp: otp,
      device_id: device_id,
      fcm_token: fcm_token,
    };
    axios.post(
      `${global.api_url}/api/register`,
      payload,
    )
    .then((response: AxiosResponse) => {
      if (response.status === 201) {
        successCallBack(response);
      } 
      else if (response.status === 200) {
        successCallBack(response);
      } 
    })
    .catch((error: AxiosError) => {
      if (error.response) {
        if (error.response.status === 400) {
          errorCallBack(error?.response?.data);
        } else if (error.response.status === 404){
          errorCallBack(error?.response?.data)
        }
        else if( error.response?.status === 409)
          {
            errorCallBack(error?.response?.data);
          }
        else if (error.response.status === 401) {
          localStorage.clear();
          toast.error("Login Expired.");
        }
      } 
      else {
        toast.error("Server Error");
      }
    });
  };
          